<div fxLayout="column" class="neq-dialog">
  <div *ngIf="message" [innerHTML]="message"></div>

  <div>
    <span style="display: inherit" *ngIf="listFormat.length > 0">
      {{ 'label.user.export.popin.list.export-format' | translate}}
      <mat-form-field style="width: 250px;">
        <mat-select [placeholder]="selectedValue.length == 0 ? ('label.user.export.popin.list.placeholder.export-format' | translate) : ''" [(ngModel)]="selectedValue" multiple>
          <mat-option *ngFor="let format of listFormat" [value]="format">{{format}}</mat-option>
        </mat-select>
      </mat-form-field>
    </span>
  </div>

  <ng-container *ngIf="entities">
    <ul>
      <li *ngFor="let entity of entities">
        {{ entity.entityLabel }}
        <ul>
          <li *ngFor="let rawMatCode of entity.rmCodes">
            {{ rawMatCode.rmCode }} {{ rawMatCode.rmLabel }}
          </li>
        </ul>
      </li>
    </ul>
  </ng-container>

  <div class="asi-container" fxLayout="row" fxLayoutAlign="center center">
    <button
      pButton
      class="neq-primeng-button-text"
      [disabled]="selectedValue.length == 0"
      (click)="continue()"
      label="{{'msg.common.validation.ok' | translate}}"></button>
    <button
      pButton
      class="neq-primeng-button-text"
      (click)="goBack()"
      label="{{'msg.common.validation.cancel' | translate}}"></button>
  </div>
</div>
